/* eslint-disable @typescript-eslint/no-explicit-any */
import { useCallback, useState } from 'react';
import classNames from 'classnames';
import { ReactComponent as ChevroneIcon } from '@Icons/additional/chevron-right.svg';
import styles from './card.module.css';
import VendorCardDetails from './components/VendorCardDetails';

interface CardProps {
  unitName: string;
  qty: number;
  description: string;
  no: string | number;
  vendorDetails: any[];
}

const Card = ({
  description,
  no,
  qty,
  unitName,
  vendorDetails,
}: CardProps): JSX.Element | null => {
  const [showVendorItems, setShowVendorItems] = useState<boolean>(false);
  const handleShowVendorItems = useCallback(() => {
    setShowVendorItems(!showVendorItems);
  }, [showVendorItems]);

  return (
    <div className={styles.card} onClick={handleShowVendorItems}>
      <div className={styles.cardManageSection}>
        <div className={styles.cardType}>
          <div className={styles.cardCaption}>Material No. {no}</div>
          <div className={styles.cardDescription}>{description}</div>
        </div>
        <div
          className={classNames(
            styles.cardChevrone,
            showVendorItems ? styles.cardChevroneExpanded : null
          )}
        >
          <ChevroneIcon />
        </div>
      </div>
      <div className={styles.cardInfoSection}>
        <div className={styles.cardInfoType}>
          <span>Unit</span>
          <span className={unitName.length > 10 ? styles.textOverflow : ''}>
            {unitName}
          </span>
        </div>
        <div className={styles.cardInfoType}>
          <span>Required Quantity</span>
          <span>{qty}</span>
        </div>
      </div>
      {vendorDetails?.length && showVendorItems && (
        <VendorCardDetails vendorList={vendorDetails} />
      )}
    </div>
  );
};

export default Card;
